import { Box, Button, Container, TextField, Typography } from "@mui/material";

import { useState } from "react";
import { saveContactMessage } from "../firebase/fireStoreServices";

export default function Contact() {
  const [formData, SetFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    SetFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const success = saveContactMessage(formData);

    if (success) {
      SetFormData({ name: "", email: "", message: "" });
    } else {
      alert("❌ Failed to send message. Please try again.");
    }

    setIsSubmitting(false);
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ textAlign: "center", my: 4 }}>
        <Typography variant="h4" fontWeight="bold" color="primary">
          Contact Us
        </Typography>

        <Typography variant="body1" sx={{ mb: 3, fontWeight: "bold" }}>
          Have a question or feedback? We'd love to hear from you!
        </Typography>

        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{ display: "flex", flexDirection: "column", gap: 2 }}
        >
          <TextField
            label="Name"
            name="name"
            fullWidth
            required
            value={formData.name}
            onChange={handleChange}
          >
            Name
          </TextField>

          <TextField
            label="Email"
            name="email"
            fullWidth
            required
            value={formData.email}
            onChange={handleChange}
          >
            Email
          </TextField>

          <TextField
            label="Message"
            name="message"
            fullWidth
            required
            value={formData.message}
            onChange={handleChange}
          >
            Message
          </TextField>
          <Button
            variant="contained"
            size="large"
            disabled={isSubmitting}
            onClick={handleSubmit}
            sx={{
              mt: 3,
              background: "linear-gradient(90deg, #FF9800 0%, #FF5722 100%)",
              fontSize: "1.1rem",
              fontWeight: "bold",
              color: "white",
              px: 4,
              py: 1.5,
              borderRadius: 3,
              boxShadow: "0 5px 15px rgba(255, 87, 34, 0.3)",
              "&:hover": {
                background: "linear-gradient(90deg, #FF5722 0%, #E64A19 100%)",
              },
            }}
          >
            {isSubmitting ? "Sending..." : "Send Message"}
          </Button>
        </Box>
      </Box>
    </Container>
  );
}
